import styled from "@emotion/styled";
export const StyledUsersSelect = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  .billing-users-selection {
    margin-left: 12px;
    min-width: 190px;
    z-index: 10;
  }
`;
